import './LandInnovationDrawer.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Drawer } from 'antd'

export const innovationDrawerHeight = 250

export default class LandInnovationDrawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <Drawer
        height={innovationDrawerHeight}
        title={null}
        placement="top"
        closeIcon={null}
        open={this.props.open}
        rootStyle={{ position: 'fixed', top: '10vh', zIndex: 100 }}
        styles={{
          header: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
          body: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
        }}
      >
        <div className="LandInnovationWrapper">
          <div
            className="LandInnovationView"
            onClick={() => {
              this.props.handleClose()
              this.viewProductLine()
            }}
          >
            定制化柔性生产线
          </div>
          <div
            className="LandInnovationView"
            onClick={() => {
              this.props.handleClose()
              this.viewOverallSolution()
            }}
          >
            整体解决方案
          </div>
          <div
            className="LandInnovationView"
            onClick={() => {
              this.props.handleClose()
              this.viewOnsiteGuidance()
            }}
          >
            现场工程指导
          </div>
        </div>
      </Drawer>
    )
  }

  viewProductLine = () => {
    this.props.history.push('/product_line')
  }

  viewOverallSolution = () => {
    this.props.history.push('/overall_solution')
  }

  viewOnsiteGuidance = () => {
    this.props.history.push('/onsite_guidance')
  }
}
